import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { OnboardingCtaComponent } from "@m19-board/containers/board-layout/board-sidebar/onboarding-cta.component";
import { FeaturePitchOverlayComponent } from "@m19-board/overlay/feature-pitch-overlay/feature-pitch-overlay.component";
import { OverlayRule } from "@m19-board/overlay/overlay-service/overlay-rules";

@Component({
  selector: "app-tacos-start-free-test-overlay",
  imports: [TranslocoDirective, FeaturePitchOverlayComponent, OnboardingCtaComponent],
  template: `
    <app-feature-pitch-overlay *transloco="let t" feature="tacos" [title]="t('overlays.start_free_test_tacos_title')">
      <app-onboarding-cta overlayCta />
    </app-feature-pitch-overlay>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TacosStartFreeTestOverlayComponent {
  static readonly rule = OverlayRule.START_FREE_TEST;
}
